<!-- 4. CURSOS Y EDUCACIÓN -->
<div class="courses-section" id="cursos">
  <!-- Encabezado: mismo patrón que servicios (título + párrafo centrados) -->
  <header class="courses-head">
    <h2 class="section-title2" appRevealOnScroll>Testimonios</h2>
    <p class="courses-lead">
      Lo que cuentan quienes ya iniciaron su proceso con nosotros, con sus
      propias palabras.
    </p>
  </header>

  <!-- Las flechas se centran respecto al carrusel, no a toda la sección -->
  <div class="carousel-wrap">
  <!-- Botón izquierda -->
  <button class="carousel-btn left" (click)="prevSlide()">
    <div class="arrow">
      <div class="arrow-top"></div>
      <div class="arrow-bottom"></div>
    </div>
  </button>

  <div class="carousel" #carousel (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()" (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)" (touchcancel)="onTouchEnd()">

    <!-- Track -->
    <div class="carousel-track" #track (transitionend)="onTransitionEnd()"
      [style.transform]="'translateX(' + currentTranslate + 'px)'">

      <!-- .card conserva su ancho y márgenes: el carrusel los usa para calcular el desplazamiento -->
      <div class="card" *ngFor="let course of slides">
        <div class="testimonial-head">
          <i class="fas fa-quote-left testimonial-quote" aria-hidden="true"></i>
          <span class="testimonial-tag">{{ course.focus }}</span>
        </div>

        <p class="testimonial-text">{{ course.text }}</p>

        <div class="testimonial-author">
          <div class="testimonial-icon" aria-hidden="true">
            <i class="fas fa-user"></i>
          </div>
          <span class="title">{{ course.name }}</span>
        </div>
      </div>
    </div>

  </div>
  <!-- Botón derecha (oculto en móviles con CSS) -->
  <!-- Botón derecha -->
  <button class="carousel-btn right" (click)="nextSlide()">
    <div class="arrow arrow-right">
      <div class="arrow-top"></div>
      <div class="arrow-bottom"></div>
    </div>
  </button>
  </div>
</div>